import propTypes from 'prop-types';
import { Box, Divider, Typography } from '@material-ui/core';
import CheckIcon from '../../icons/Check';

const PricingPlan = (props) => {
  const {
    currency,
    description,
    features,
    name,
    popular,
    price,
    interval, // neuen Prop mitnehmen
    sx,
    ...other
  } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        ...sx
      }}
      {...other}
    >
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: 'flex' }}>
          <Typography
            color="textPrimary"
            variant="h6"
          >
            {currency}
          </Typography>
          <Typography
            color="textPrimary"
            variant="h4"
          >
            {price}
          </Typography>
          <Typography
            color="textSecondary"
            sx={{
              alignSelf: 'flex-end',
              ml: 1
            }}
            variant="subtitle2"
          >
            {interval}
          </Typography>
        </Box>
        <Typography
          color="textPrimary"
          sx={{ mt: 2 }}
          variant="h6"
        >
          {name}
        </Typography>
        <Typography
          color="textSecondary"
          sx={{ mt: 2 }}
          variant="body2"
        >
          {description}
        </Typography>
      </Box>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          p: 3
        }}
      >
        {features.map((feature) => (
          <Box
            key={feature}
            sx={{
              alignItems: 'center',
              display: 'flex',
              '& + &': {
                mt: 2
              }
            }}
          >
            <CheckIcon
              fontSize="small"
              sx={{ color: 'text.primary' }}
            />
            <Typography
              color="textPrimary"
              sx={{
                fontWeight: 500,
                ml: 2
              }}
              variant="body2"
            >
              {feature}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

PricingPlan.propTypes = {
  currency: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  features: propTypes.array.isRequired,
  name: propTypes.string.isRequired,
  popular: propTypes.bool,
  price: propTypes.string.isRequired,
  interval: propTypes.string, // Typisierung des neuen Props
  sx: propTypes.object
};

PricingPlan.defaultProps = {
  interval: '/Monat' // Standardwert setzen
};

export default PricingPlan;
